import React from "react";
import { Box, Grid } from "@material-ui/core";
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { PAYMENT_BUTTON_COMPONENTS } from "../../../../../../constants";
import { CodeSnippet } from "../../../../../CodeSnippet";
import { SrButton, SrTitle } from "../../../../../common";
import useStyles from "../paymentStyles";

const optionalInputs = ({ stores, transactionId, cancelUrl, successUrl }) => [
  {
    id: "stores",
    value: stores,
  },
  {
    id: "transaction_id",
    value: transactionId,
  },
  {
    id: "cancel_url",
    value: cancelUrl,
  },
  {
    id: "success_url",
    value: successUrl,
  },
];

const generateStringButtonCode = (props) => {
  const { ecomId, reference, amount, alt } = props;

  return `<form action="${
    process.env.REACT_APP_API_HOST
  }/web/ecommerce/transaction" class="btnSrPago" method="post" target="_blank">
  <input type="hidden" id="ecom_id" name="ecom_id" value="${ecomId}" />
  <input type="hidden" id="reference" name="reference" value="${reference}" />
  <input type="hidden" id="amount" name="amount" value="${amount}" />
${optionalInputs(props)
  .filter(({ value }) => Boolean(value))
  .map(
    (input) =>
      `  <input type="hidden" id="${input.id}" name="${input.id}" value="${input.value}" />`
  )
  .join("\n")}
  <input type="image" src="https://d1e3z1ywa42j7e.cloudfront.net/r2/checkout/payment-m.png" style="width:110px" alt="${alt}"/>
</form>`;
};

const renderPaymentButton = (props) => {
  const { ecomId, reference, amount, alt } = props;

  return (
    <form
      action={`${process.env.REACT_APP_API_HOST}/web/ecommerce/transaction`}
      className="btnSrPago"
      method="post"
      target="_blank"
    >
      <input type="hidden" id="ecom_id" name="ecom_id" value={ecomId} />
      <input type="hidden" id="reference" name="reference" value={reference} />
      <input type="hidden" id="amount" name="amount" value={amount} />
      {optionalInputs(props)
        .filter(({ value }) => Boolean(value))
        .map((input) => (
          <input
            key={input.id}
            type="hidden"
            id={input.id}
            name={input.id}
            value={input.value}
          />
        ))}
      <input
        type="image"
        src="https://d1e3z1ywa42j7e.cloudfront.net/r2/checkout/payment-m.png"
        style={{ width: "110px" }}
        alt={alt}
      />
    </form>
  );
};

const NewPaymentButton = ({ setPaymentButtonPage, formValues }) => {
  const classes = useStyles();
  const ecomId = useSelector(({ auth }) => auth.user?.ecom_id);
  const intl = useIntl();

  const buttonProps = {
    ...formValues,
    ecomId,
    alt: intl.formatMessage({
      id: "ecommerce.botonDePago.paymentButtonForm.paymentGatewayButton",
    }),
  };

  return (
    <>
      <SrButton
        startIcon={<ArrowBackIcon color="primary" />}
        onClick={() => {
          setPaymentButtonPage?.(PAYMENT_BUTTON_COMPONENTS[0]);
        }}
      >
        <FormattedMessage id="common.return" />
      </SrButton>
      <Box maxWidth={720} m="auto">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <SrTitle>
              <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.heading" />
            </SrTitle>
          </Grid>
          <Grid item xs={4} container justifyContent="flex-end">
            <SrButton
              onClick={() => setPaymentButtonPage(PAYMENT_BUTTON_COMPONENTS[1])}
              startIcon={<EditIcon fontSize="small" />}
            >
              <FormattedMessage id="common.edit" />
            </SrButton>
          </Grid>
          <Grid item xs={12}>
            <Grid container component="ul" spacing={1} className={classes.list}>
              <Grid item xs={12} component="li">
                <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.description.pt1" />
              </Grid>
              <Grid item xs={12} component="li">
                <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.description.pt2" />
              </Grid>
              <Grid item xs={12} component="li">
                <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.description.pt3" />
              </Grid>
              <Grid item xs={12} component="li">
                <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.description.pt4" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CodeSnippet code={generateStringButtonCode(buttonProps)} />
          </Grid>
          <Grid item xs={12}>
            <FormattedMessage id="ecommerce.botonDePago.paymentButtonForm.disclaimer" />
          </Grid>
          <Grid item xs={12} container justifyContent="flex-start">
            {renderPaymentButton(buttonProps)}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

NewPaymentButton.propTypes = {
  setPaymentButtonPage: PropTypes.func.isRequired,
  formValues: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    reference: PropTypes.string.isRequired,
    stores: PropTypes.number,
    transactionId: PropTypes.string,
    cancelUrl: PropTypes.string,
    successUrl: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
};

export default NewPaymentButton;
